import React from 'react'
import Image from '../../../images/buyerpolicies/Delivery And Cancellations.png'

const Delivery_and_cancellations = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Delivery And Cancellations</h2>
            <p>We are proud to say that we deliver in every part of the country. We have been assisted by express courier services to be able to deliver everywhere in Pakistan. You can return the goods shipped to you or terminate acquisitions by contacting the client support services, which you can easily find on the website. Make sure you send the courier within seven days of delivery; otherwise, it will not be accepted. It is also vital to have all the items packed and sent in exactly the same condition you received them.</p>
            <p>If you feel that your shipment has been delayed and you do not want to receive the order, you cannot just terminate the order without being liable for it. When the shipment has been sent, the buyer will receive the order. There won’t be a cancellation until you inform KAAY by phone or email. If your product has been stopped, KAAY has the right to end the order and reimburse the remaining amount. You will be informed about any remaining items or products you can replace.</p>
        </div>
      </div>
    </div>
  )
}

export default Delivery_and_cancellations
